import React, { useEffect, useRef } from "react";
import { CustomTextField } from "../Utility/Utility";
import SearchIcon from "@material-ui/icons/Search";
import {
  FormControlLabel,
  FormGroup,
  InputAdornment,
  makeStyles,
} from "@material-ui/core";
import { IOSSwitch } from "../Utility/iosSwitch";
import { useDispatch, useSelector } from "react-redux";
import {
  getEinvoiceData,
  setCheckedCancel,
  setCheckedCancelPayload,
  setCheckedIrn,
  setCheckedIrnNotGen,
  setCheckedIrnNotGenPayload,
  setCheckedIrnPayload,
  setSearchStr,
  setStatusCode,
  setStatusCodeCancel,
  setStatusCodeNotGen,
} from "./action";

const useStyles = makeStyles({
  label: {
    fontSize: "12px",
    fontWeight: 600,
    color: "black",
  },
});
const FilterBar = (props) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const debounceTimeout = useRef(null);
  const {
    searchStr,
    checkedCancel,
    checkedIrn,
    loaderStatus,
    checkedIrnNotGen,
  } = useSelector((state) => state.EinvReducerNew);

  const handleInputChange = (event) => {
    const value = event.target.value;
      dispatch(setCheckedIrnPayload(false));
      dispatch(setCheckedCancelPayload(false));
      dispatch(setCheckedIrnNotGenPayload(false));
    if (value.length > 50) {
      console.log("Value too long, blocking input");
      return;
    }
    dispatch(setSearchStr(value)); // only update state if <= 50 chars

    if (debounceTimeout.current) {
      clearTimeout(debounceTimeout.current);
    }

    debounceTimeout.current = setTimeout(() => {
      dispatch(getEinvoiceData(value));
    }, 500);
  };

  const handleCheckedIrn = () => {
    // console.log("handleCheckedIrn called");
    dispatch(setCheckedIrn());

    // Update local state based on new checked value
    if (!checkedIrn) {
      dispatch(setCheckedCancelPayload(false));
      dispatch(setCheckedIrnNotGenPayload(false));
      dispatch(setStatusCodeCancel(""));
      dispatch(setStatusCodeNotGen(""));
      dispatch(setStatusCode(1));
    } else {
      dispatch(setStatusCode(""));
    }

    // Fetch updated data after state updates
    // console.log(
    //   "payload handleCheckedIrn::",
    //   searchStr,
    //   "",
    //   !checkedIrn ? 1 : ""
    // );
    dispatch(getEinvoiceData(searchStr, "", !checkedIrn ? 1 : ""));
    props.setPageNumber(1);
  };

  const handleCheckedCancel = () => {
    // console.log("handleCheckedCancel called");
    dispatch(setCheckedCancel());
    if (!checkedCancel) {
      dispatch(setCheckedIrnPayload(false));
      dispatch(setCheckedIrnNotGenPayload(false));
      dispatch(setStatusCode(""));
      dispatch(setStatusCodeNotGen(""));
      dispatch(setStatusCodeCancel(2));
    } else {
      dispatch(setStatusCodeCancel(""));
    }
    // console.log(
    //   "payload handleCheckedCancel::",
    //   searchStr,
    //   "",
    //   !checkedCancel ? 2 : ""
    // );
    dispatch(getEinvoiceData(searchStr, "", !checkedCancel ? 2 : ""));
    props.setPageNumber(1);
  };

  const handleCheckedIrnNotGen = () => {
    // console.log("handleCheckedIrnNotGen called");
    dispatch(setCheckedIrnNotGen());
    if (!checkedIrnNotGen) {
      dispatch(setCheckedCancelPayload(false));
      dispatch(setCheckedIrnPayload(false));

      dispatch(setStatusCode(""));
      dispatch(setStatusCodeCancel(""));
      dispatch(setStatusCodeNotGen(3));
    } else {
      dispatch(setStatusCodeNotGen(""));
    }
    // console.log(
    //   "payload handleCheckedIrnNotGen::",
    //   searchStr,
    //   "",
    //   !checkedIrnNotGen ? 3 : ""
    // );
    dispatch(getEinvoiceData(searchStr, "", !checkedIrnNotGen ? 3 : ""));
    props.setPageNumber(1);
  };

  useEffect(() => {
    return () => {
      dispatch(setSearchStr(""));
    };
  }, []);

  return (
    <div style={{ display: "flex", justifyContent: "flex-start" }}>
      <div style={{ width: "35%" }}>
        <CustomTextField
          style={{ backgroundColor: "white" }}
          placeholder="Search.."
          variant="outlined"
          size="small"
          value={searchStr}
          onChange={(e) => handleInputChange(e)}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon />
              </InputAdornment>
            ),
          }}
        />
      </div>

      <FormGroup>
        <div style={{ display: "flex", gap: "12px", marginTop: "-0.5em" }}>
          <FormControlLabel
            control={
              <IOSSwitch
                checked={checkedIrn}
                onChange={handleCheckedIrn}
                name="IRN"
                disabled={loaderStatus}
              />
            }
            classes={{ label: classes.label }}
            label="IRN"
            style={{
              fontSize: "12px",
              fontWeight: "600",
              marginLeft: "1em",
              fontFamily: "GT-Walsheim-medium",
            }}
          />

          <FormControlLabel
            control={
              <IOSSwitch
                checked={checkedIrnNotGen}
                onChange={handleCheckedIrnNotGen}
                name="IRNnotGenerated"
                disabled={loaderStatus}
              />
            }
            classes={{ label: classes.label }}
            label="IRN Not Generated"
            style={{
              fontSize: "12px",
              fontWeight: "600",
              marginLeft: "1em",
              fontFamily: "GT-Walsheim-medium",
            }}
          />

          <FormControlLabel
            control={
              <IOSSwitch
                checked={checkedCancel}
                onChange={handleCheckedCancel}
                name="Cancel"
                disabled={loaderStatus}
              />
            }
            classes={{ label: classes.label }}
            label="Cancel"
            style={{
              fontSize: "12px",
              fontWeight: "600",
              marginLeft: "1em",
              fontFamily: "GT-Walsheim-medium",
            }}
          />
        </div>
      </FormGroup>
    </div>
  );
};

export default FilterBar;
